export default {
    backgroundImages : [
        {name:'Light Pipes', url: require('@/_static/img/background/bag1.jpg')},
        // {name:'Blue Sky Refinery',url: require('@/_static/img/background/bag2.jpg')},
        {name:'Perspectives',url: require('@/_static/img/background/bag3.jpg')},
        {name:'Night Work',url: require('@/_static/img/background.jpg')},
        {name:'Greece',url: require('@/_static/img/background/greece0.jpg')},
        {name:'Nature',url: require('@/_static/img/background/nature-001.jpg')},
        {name:'Plant Walk',url: require('@/_static/img/background/plant-walk.jpg')},
        {name:'Ocean Waaves',url: require('@/_static/img/background/ocean-waves.jpg')},
    ],
    themeConfigs : {
        default : {
            "default-dark" : 
            {
                name : "Dark (default)",
                config : {
                    navBackgroundColor : { r: 0, g: 0, b: 0, a: 1 },                   
                    contentBackgroundColor:{ r: 0, g: 0, b: 0, a: 1 },
                    appBackgroundColor:{ r: 0, g: 0, b: 0, a: 1 },
                    backgroundImage:"",
                    dark:true 
                }
            },
            "default-light" : 
            {
                name : "Light (default)",
                config : {
                    navBackgroundColor : { r: 255, g: 255, b: 255, a: 1 },                    
                    contentBackgroundColor:{ r: 255, g: 255, b: 255, a: 1 },       
                    appBackgroundColor:{ r: 255, g: 255, b: 255, a: 1 },       
                    backgroundImage:"",
                    dark:false 
                    
                }
            }
        },
    }
}